import {
  GET_EXECUTIVE_LIST_BY_ID_REQUEST,
  GET_EXECUTIVE_LIST_BY_ID_SUCCESS,
  GET_EXECUTIVE_LIST_BY_ID_FAILURE,
  GET_EXECUTIVE_LIST_BY_EXECUTIVE_PERSON_ID_REQUEST,
  GET_EXECUTIVE_LIST_BY_EXECUTIVE_PERSON_ID_SUCCESS,
  GET_EXECUTIVE_LIST_BY_EXECUTIVE_PERSON_ID_FAILURE,
  POST_EXECUTIVE_LIST_SEARCH_RIVAL_REQUEST,
  POST_EXECUTIVE_LIST_SEARCH_RIVAL_SUCCESS,
  POST_EXECUTIVE_LIST_SEARCH_RIVAL_FAILURE,
  POST_EXECUTIVE_LIST_SEARCH_PARENT_CORPORATION_KEYMAN_LIST_REQUEST,
  POST_EXECUTIVE_LIST_SEARCH_PARENT_CORPORATION_KEYMAN_LIST_SUCCESS,
  POST_EXECUTIVE_LIST_SEARCH_PARENT_CORPORATION_KEYMAN_LIST_FAILURE,
  POST_EXECUTIVE_LIST_SEARCH_CHILD_CORPORATION_KEYMAN_LIST_REQUEST,
  POST_EXECUTIVE_LIST_SEARCH_CHILD_CORPORATION_KEYMAN_LIST_SUCCESS,
  POST_EXECUTIVE_LIST_SEARCH_CHILD_CORPORATION_KEYMAN_LIST_FAILURE,
  POST_EXECUTIVE_LIST_SEARCH_SAME_DEPARTMENT_INCLUDE_PARENT_AND_CHILD_CORPORATION_KEYMAN_LIST_REQUEST,
  POST_EXECUTIVE_LIST_SEARCH_SAME_DEPARTMENT_RELATED_CORPORATION_KEYMAN_LIST_SUCCESS,
  POST_EXECUTIVE_LIST_SEARCH_SAME_DEPARTMENT_RELATED_CORPORATION_KEYMAN_LIST_FAILURE,
  LOG_OUT_SUCCESS,
} from '../../constants/ActionTypes'
import * as errMessages from '../../constants/ErrorMessages';

const initialState = {
  item: null,
  isLoading: false,
  currentId: null,
  rivalExecList: [],
  isLoadingRival: false,
  rivalTotal: 0,
  parentCorporationKeymanList: [],
  isLoadingParentCorporationKeymanList: false,
  parentCorporationKeymanListTotal: 0,
  childCorporationKeymanList: [],
  isLoadingChildCorporationKeymanList: false,
  childCorporationKeymanListTotal: 0,
  sameDepartmentIncludeParentAndChildCorporationKeymanList: [],
  isLoadingSameDepartmentIncludeParentAndChildCorporationKeymanList: false,
  sameDepartmentIncludeParentAndChildCorporationKeymanListTotal: 0,
}

export default (state = initialState, action) => {
  state = {
    ...state,
    message: '',
    errorMessage: ''
  }

  switch (action.type) {
    case GET_EXECUTIVE_LIST_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true,
        currentId: action.payload.id,
      }
    case GET_EXECUTIVE_LIST_BY_ID_SUCCESS:
      if (action.payload.id === state.currentId) {
        return {
          ...state,
          isLoading: false,
          item: action.payload.item
        }
      } else {
        return state;
      }
    case GET_EXECUTIVE_LIST_BY_ID_FAILURE:
      if (action.payload.id === state.currentId) {
        return {
          ...state,
          isLoading: false,
          errorMessage: errMessages.ERR_GET_FAILURE,
        }
      } else {
        return state;
      }
    case GET_EXECUTIVE_LIST_BY_EXECUTIVE_PERSON_ID_REQUEST:
      // 別キーマンのitemが残っていると、取得失敗時（ESにデータがない等）に前のキーマンの名前・役職が表示されるためクリアする
      return {
        ...state,
        isLoading: true,
        currentId: action.payload.id,
        item: null,
      }
    case GET_EXECUTIVE_LIST_BY_EXECUTIVE_PERSON_ID_SUCCESS:
      if (action.payload.id === state.currentId) {
        return {
          ...state,
          isLoading: false,
          item: action.payload.item
        }
      } else {
        return state;
      }
    case GET_EXECUTIVE_LIST_BY_EXECUTIVE_PERSON_ID_FAILURE:
      if (action.payload.id === state.currentId) {
        return {
          ...state,
          isLoading: false,
          item: null,
          errorMessage: errMessages.ERR_GET_FAILURE,
        }
      } else {
        return state;
      }
    case POST_EXECUTIVE_LIST_SEARCH_RIVAL_REQUEST:
      if (action.payload.id === state.currentId) {
        return {
          ...state,
          isLoadingRival: true,
          rivalExecList: [],
        }
      } else {
        return state;
      }
    case POST_EXECUTIVE_LIST_SEARCH_RIVAL_SUCCESS:
      if (action.payload.id === state.currentId) {
        return {
          ...state,
          isLoadingRival: false,
          rivalExecList: action.payload.list,
          rivalTotal: action.payload.pageInfo ? action.payload.pageInfo.total : 0,
        }
      } else {
        return state;
      }
    case POST_EXECUTIVE_LIST_SEARCH_RIVAL_FAILURE:
      if (action.payload.id === state.currentId) {
        return {
          ...state,
          isLoadingRival: false,
        }
      } else {
        return state;
      }
    case POST_EXECUTIVE_LIST_SEARCH_PARENT_CORPORATION_KEYMAN_LIST_REQUEST:
      return {
        ...state,
        isLoadingParentCorporationKeymanList: true,
        parentCorporationKeymanList: [],
      }
    case POST_EXECUTIVE_LIST_SEARCH_PARENT_CORPORATION_KEYMAN_LIST_SUCCESS:
      return {
        ...state,
        isLoadingParentCorporationKeymanList: false,
        parentCorporationKeymanList: action.payload.list,
        parentCorporationKeymanListTotal: action.payload.pageInfo ? action.payload.pageInfo.total : 0,
      }
    case POST_EXECUTIVE_LIST_SEARCH_PARENT_CORPORATION_KEYMAN_LIST_FAILURE:
      return {
        ...state,
        isLoadingParentCorporationKeymanList: false,
      }
    case POST_EXECUTIVE_LIST_SEARCH_CHILD_CORPORATION_KEYMAN_LIST_REQUEST:
      return {
        ...state,
        isLoadingChildCorporationKeymanList: true,
        childCorporationKeymanList: [],
      }
    case POST_EXECUTIVE_LIST_SEARCH_CHILD_CORPORATION_KEYMAN_LIST_SUCCESS:
      return {
        ...state,
        isLoadingChildCorporationKeymanList: false,
        childCorporationKeymanList: action.payload.list,
        childCorporationKeymanListTotal: action.payload.pageInfo ? action.payload.pageInfo.total : 0,
      }
    case POST_EXECUTIVE_LIST_SEARCH_CHILD_CORPORATION_KEYMAN_LIST_FAILURE:
      return {
        ...state,
        isLoadingChildCorporationKeymanList: false,
      }
    case POST_EXECUTIVE_LIST_SEARCH_SAME_DEPARTMENT_INCLUDE_PARENT_AND_CHILD_CORPORATION_KEYMAN_LIST_REQUEST:
      return {
        ...state,
        isLoadingSameDepartmentIncludeParentAndChildCorporationKeymanList: true,
        sameDepartmentIncludeParentAndChildCorporationKeymanList: [],
      }
    case POST_EXECUTIVE_LIST_SEARCH_SAME_DEPARTMENT_RELATED_CORPORATION_KEYMAN_LIST_SUCCESS:
      return {
        ...state,
        isLoadingSameDepartmentIncludeParentAndChildCorporationKeymanList: false,
        sameDepartmentIncludeParentAndChildCorporationKeymanList: action.payload.list,
        sameDepartmentIncludeParentAndChildCorporationKeymanListTotal: action.payload.pageInfo ? action.payload.pageInfo.total : 0,
      }
    case POST_EXECUTIVE_LIST_SEARCH_SAME_DEPARTMENT_RELATED_CORPORATION_KEYMAN_LIST_FAILURE:
      return {
        ...state,
        isLoadingSameDepartmentIncludeParentAndChildCorporationKeymanList: false,
      }
    case LOG_OUT_SUCCESS:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/executiveDetail.js